import React, { useState } from "react";
import { Card, Button, Modal } from "asumsi-components";
export interface IProps {
    showPreviewPage: boolean;
    setShowPreviewPage: any;
    previewSlug: string;
}
export const PreveiwLangdingPage = (props: IProps) => {
    const { showPreviewPage, setShowPreviewPage, previewSlug } = props;
    const [modeDisplay, setModeDisplay] = useState('mobile');
    const onClose = () => {
        setShowPreviewPage(false);
    }

    const onLarge = () => {
        setModeDisplay('large');
    }

    const onMobile = () => {
        setModeDisplay('mobile');
    }

    return <Modal hiddenXButton={true} show={showPreviewPage} setShow={setShowPreviewPage} className="modal-preview">
        <Card className="preview-page-button">
            <Button className="m-r-10" size="medium" width="150px" type="outline-gray" text="Small Screen" onClick={onMobile} disabled={modeDisplay == 'mobile' ? true : false} />
            <Button size="medium" width="150px" type="outline-gray" text="Large Screen" onClick={onLarge} disabled={modeDisplay == 'large' ? true : false} />
            <div className="right">
                <Button size="medium" width="150px" type="outline-gray" text="Close Preview" onClick={onClose} />
            </div>
        </Card>
        <Card className="preview-page">
            <Card className={modeDisplay}>
                <iframe name="previewLanding" style={{ border: 0 }} height="100%" width="100%" src={`${process.env.REACT_APP_CF_URL}/landing-page/${previewSlug}`}></iframe>
            </Card>
        </Card>
    </Modal>
}

export default PreveiwLangdingPage;


// WEBPACK FOOTER //
// ./src/pages/landing-page-form/libraries/landingPagePreview.tsx